import { createService } from '@bonanza-social/toolkit/api';
import { LevelsResponseSchema } from './LevelsService.schemas';

export default createService(
  {
    getLevels: {
      method: 'GET',
      url: '/levels',
      responseSchema: LevelsResponseSchema,
    },
  },
  ({ userId }) => `/players/${userId}`,
);
